<template>
    <div class="processing-error position-relative h-100">
        <h2>{{ hebrew ? 'התקבלה הודעת שגיאה' : 'An error occurred' }}</h2>
        <span v-if="uploadStatusProgressresultsError">{{ hebrew ? 'קובץ שגוי' : 'Error in file' }}: {{ uploadStatusProgressresultsError }}</span>
        <span v-else>{{ uploadStatusGeneralError }}</span>
        <div class="position-absolute text-center w-100" style="bottom:0">
            <b-button
                to="/"
                variant="primary"
                size="lg"
            >
            {{ hebrew ? 'חזרה לדף הבית' : 'Back to home page' }}
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    name: "ProcessingError",
    data() {
        return {

        }
    },
    computed: {
        hebrew () {
          return this.$settings.hebrew;
        },
        uploadStatusGeneralError () {
            return this.$store.state.uploadStatus.msg
        }, 
        uploadStatusProgressresultsError () {
          return this.$store.state.uploadStatus.progress_results ? 
          this.$store.state.uploadStatus.progress_results.filter(item=> {return item.error}).map(item=> {return item.filename}).join(',') : null
        },          
      }
}
</script>    